export default "__VITE_ASSET__CtaUCu1n__"